var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRunModel = function SvgIconRunModel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.909 7.592 6.167 2.15a2.733 2.733 0 0 0-2.7 0 2.767 2.767 0 0 0-1.2 2.5v10.817a2.783 2.783 0 0 0 1.2 2.5c.372.224.8.34 1.233.333a3.276 3.276 0 0 0 1.467-.375L16.91 12.5c1.591-.833 1.825-1.867 1.825-2.433 0-.567-.234-1.667-1.825-2.475Zm-.759 3.383L5.417 16.417a1.152 1.152 0 0 1-1.083.1 1.193 1.193 0 0 1-.4-1.05V4.583a1.192 1.192 0 0 1 .4-1.05.725.725 0 0 1 .333-.091c.251.01.497.078.717.2L16.15 9.083c.567.284.917.65.917.942 0 .292-.35.658-.917.95Z"
  })));
};
export default SvgIconRunModel;